/* eslint-disable */
// Hand-authored holiday loader scene (Halloween, Oct 31) in the handoff idiom.
const rnd = (a, b) => a + Math.random() * (b - a);

/* ---- a small bat: a dark silhouette whose wings flap in place
        while an outer group glides it across the sky ---- */
function hwBat(y, sc, dur, delay, wingDelay) {
  const c = '#160b26';
  return `<g transform="translate(0,${y})"><g class="hw-bat" style="animation-duration:${dur}s;animation-delay:${delay}s"><g transform="scale(${sc})">
    <g class="hw-wing" style="animation-delay:${wingDelay}s">
      <path d="M0,0 C -5,-6 -11,-6 -18,-1 C -13,-2 -11,2 -6,1 C -4,3 -1,2 0,0 Z" fill="${c}"/>
      <path d="M0,0 C 5,-6 11,-6 18,-1 C 13,-2 11,2 6,1 C 4,3 1,2 0,0 Z" fill="${c}"/>
    </g>
    <ellipse cx="0" cy="0" rx="2.2" ry="3" fill="${c}"/>
    <path d="M-2,-2.6 L-3.2,-5.5 L-0.4,-3.6 Z" fill="${c}"/>
    <path d="M2,-2.6 L3.2,-5.5 L0.4,-3.6 Z" fill="${c}"/>
  </g></g></g>`;
}

/* ---- a gnarled bare tree, built from tapering stroke branches so
        it reads as a spooky winter silhouette against the sky ---- */
function hwBareTree(x, gy, s, c) {
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <g stroke="${c}" fill="none" stroke-linecap="round">
      <path d="M0,0 C 1,-18 -3,-30 -2,-46" stroke-width="8"/>
      <path d="M0,0 C -7,-1 -12,1 -17,4" stroke-width="3"/>
      <path d="M0,0 C 7,-1 12,0 17,3" stroke-width="3"/>
      <path d="M-1.5,-38 C -9,-44 -15,-50 -24,-52" stroke-width="4.5"/>
      <path d="M-24,-52 C -30,-53 -33,-58 -36,-62" stroke-width="2.2"/>
      <path d="M-16,-49 C -18,-56 -20,-60 -19,-67" stroke-width="2"/>
      <path d="M0.5,-46 C 7,-52 12,-58 15,-70" stroke-width="4.5"/>
      <path d="M15,-70 C 16,-76 20,-79 24,-83" stroke-width="2.2"/>
      <path d="M8,-56 C 9,-64 7,-70 9,-78" stroke-width="2"/>
      <path d="M-2,-52 C -4,-62 -3,-70 -5,-80" stroke-width="2.6"/>
      <path d="M-5,-80 C -7,-84 -6,-88 -9,-92" stroke-width="1.5"/>
      <path d="M-2,-64 C 2,-70 5,-74 4,-82" stroke-width="1.6"/>
    </g>
  </g>`;
}

/* ---- a low fog wisp; a soft radial ellipse drifting sideways ---- */
function hwFog(x, y, sc, o, dur, dl, uid) {
  return `<g transform="translate(${x},${y})"><g class="drift" style="animation-duration:${dur}s;animation-delay:${dl}s"><g transform="scale(${sc})">
    <ellipse cx="0" cy="0" rx="62" ry="9" fill="url(#fog_${uid})" opacity="${o}"/>
  </g></g></g>`;
}

/* ---- the hero jack-o'-lantern: plump lobed body, curled stem and a
        carved face lit from a warm gradient, a flickering candle-glow
        halo (class glow) pulsing behind it ---- */
function hwJack(x, gy, s, uid) {
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <g class="glow"><ellipse cx="0" cy="-13" rx="34" ry="27" fill="url(#pkGlow_${uid})"/></g>
    <path d="M-2,-29 C -5,-41 6,-44 4,-30" fill="#5f7a35"/>
    <path d="M-2,-29 C -4,-38 2,-41 3,-33" fill="#42561f"/>
    <ellipse cx="0" cy="-13" rx="22" ry="17.5" fill="url(#pkBody_${uid})"/>
    <ellipse cx="-11" cy="-12" rx="12" ry="16" fill="url(#pkBody_${uid})"/>
    <ellipse cx="11" cy="-12" rx="12" ry="16" fill="url(#pkBody_${uid})"/>
    <ellipse cx="-5.5" cy="-12" rx="8.5" ry="17" fill="url(#pkBody_${uid})"/>
    <ellipse cx="5.5" cy="-12" rx="8.5" ry="17" fill="url(#pkBody_${uid})"/>
    <ellipse cx="0" cy="-12" rx="10" ry="17.5" fill="url(#pkBody_${uid})"/>
    <g stroke="#a8440d" stroke-width="1.4" fill="none" opacity="0.5" stroke-linecap="round">
      <path d="M-6,-27 C -12,-19 -12,-6 -8,2"/>
      <path d="M6,-27 C 12,-19 12,-6 8,2"/>
      <path d="M0,-29 C -1,-18 -1,-6 0,2"/>
    </g>
    <g fill="url(#pkFace_${uid})">
      <path d="M-15,-20 L-6,-17 L-11,-11 Z"/>
      <path d="M15,-20 L6,-17 L11,-11 Z"/>
      <path d="M0,-16 L-3.4,-9 L3.4,-9 Z"/>
      <path d="M-15,-5 L-9,-4 L-7,-8 L-3,-4 L0,-8 L3,-4 L7,-8 L9,-4 L15,-5 L11,2 L-11,2 Z"/>
    </g>
  </g>`;
}

/* ---- a small unlit gourd, a dark grounding silhouette ---- */
function hwGourd(x, gy, s) {
  const c = '#241634';
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <path d="M-1,-15 C -3,-21 3,-22 2,-16" fill="#33421c"/>
    <ellipse cx="0" cy="-7" rx="13" ry="10" fill="${c}"/>
    <ellipse cx="-6" cy="-7" rx="7" ry="9.5" fill="${c}"/>
    <ellipse cx="6" cy="-7" rx="7" ry="9.5" fill="${c}"/>
    <ellipse cx="0" cy="-7" rx="4.5" ry="10" fill="${c}"/>
  </g>`;
}

/* ---- a floating ghost: translucent body with a wavy hem, dark eyes
        and mouth, a soft glow halo, bobbing gently (class hw-bob) ---- */
function hwGhost(x, y, s, uid, bobDelay) {
  return `<g transform="translate(${x},${y})"><g class="hw-bob" style="animation-delay:${bobDelay}s"><g transform="scale(${s})">
    <g class="glow"><ellipse cx="0" cy="-2" rx="27" ry="29" fill="url(#ghostGlow_${uid})"/></g>
    <path d="M0,-26 C -16,-26 -18,-10 -18,4 L-18,20 L-12,14 L-6,20 L0,14 L6,20 L12,14 L18,20 L18,4 C 18,-10 16,-26 0,-26 Z" fill="url(#ghost_${uid})"/>
    <ellipse cx="-6" cy="-8" rx="2.6" ry="3.6" fill="#2a1740"/>
    <ellipse cx="6" cy="-8" rx="2.6" ry="3.6" fill="#2a1740"/>
    <ellipse cx="0" cy="1" rx="3" ry="4" fill="#2a1740"/>
  </g></g></g>`;
}

/* ---- a low wrought-iron graveyard fence: thin bars with spear finials
        and two rails, a dark silhouette hugging the ground ---- */
function hwFence(x0, x1, gy, c) {
  let bars = '';
  for (let x = x0; x <= x1; x += 9) {
    bars += `<line x1="${x}" y1="${gy}" x2="${x}" y2="${gy - 16}" stroke="${c}" stroke-width="1.6"/>`;
    bars += `<path d="M${x - 2.2},${gy - 15} L${x},${gy - 20} L${x + 2.2},${gy - 15} Z" fill="${c}"/>`;
  }
  return `<g>${bars}<rect x="${x0}" y="${gy - 13}" width="${x1 - x0}" height="2" fill="${c}"/><rect x="${x0}" y="${gy - 6}" width="${x1 - x0}" height="2" fill="${c}"/></g>`;
}

/* ---- a rounded headstone with a small engraved cross, leaning a touch ---- */
function hwGrave(x, gy, s, lean) {
  return `<g transform="translate(${x},${gy}) rotate(${lean}) scale(${s})">
    <path d="M-11,0 L-11,-19 Q-11,-30 0,-30 Q11,-30 11,-19 L11,0 Z" fill="#271a3c"/>
    <path d="M-7.5,-2 L-7.5,-18 Q-7.5,-26 0,-26 Q7.5,-26 7.5,-18 L7.5,-2 Z" fill="#372a4f" opacity="0.55"/>
    <g stroke="#1a1230" stroke-width="1.5" stroke-linecap="round"><line x1="0" y1="-23" x2="0" y2="-12"/><line x1="-3.6" y1="-19" x2="3.6" y2="-19"/></g>
  </g>`;
}

/* ---- a corner cobweb: radial spokes and connecting threads spun from a
        corner anchor (a0..a1 sweep the quarter into the scene) ---- */
function hwCobweb(ox, oy, r, a0, a1) {
  const st = 'rgba(212,204,236,.42)';
  const n = 5;
  let spokes = '', arcs = '';
  for (let i = 0; i < n; i++) {
    const a = a0 + (a1 - a0) * (i / (n - 1));
    spokes += `<line x1="${ox}" y1="${oy}" x2="${(ox + Math.cos(a) * r).toFixed(1)}" y2="${(oy + Math.sin(a) * r).toFixed(1)}"/>`;
  }
  [0.34, 0.62, 0.9].forEach((f) => {
    let d = '';
    for (let i = 0; i < n; i++) {
      const a = a0 + (a1 - a0) * (i / (n - 1));
      const x = ox + Math.cos(a) * r * f, y = oy + Math.sin(a) * r * f;
      d += (i === 0 ? `M${x.toFixed(1)},${y.toFixed(1)}` : ` L${x.toFixed(1)},${y.toFixed(1)}`);
    }
    arcs += `<path d="${d}"/>`;
  });
  return `<g stroke="${st}" stroke-width="0.7" fill="none">${spokes}${arcs}</g>`;
}

/* ---- a wispy spirit orb: a soft pulsing halo (class glow) around a bright
        core, floating gently (class hw-bob) ---- */
function hwOrb(x, y, s, uid, delay, dur) {
  return `<g transform="translate(${x},${y})"><g class="hw-bob" style="animation-delay:${delay}s;animation-duration:${dur}s"><g transform="scale(${s})">
    <g class="glow"><circle r="9" fill="url(#orbGlow_${uid})"/></g>
    <circle r="2.4" fill="#e9fff4" opacity="0.9"/>
  </g></g></g>`;
}

function halloweenScene() {
  const pick = (a) => a[Math.floor(Math.random() * a.length)];
  const uid  = 'h' + Math.random().toString(36).slice(2, 7);

  // ---- rolled traits ----
  const night = pick(['dusk', 'midnight']);       // warm low moon vs cool high moon
  const hero  = pick(['lantern', 'lantern', 'ghost']); // jack-o'-lantern headlines; ghost is the twist

  const SKIES = {
    dusk:     ['#1b1140', '#3a1e50', '#5c3050'],
    midnight: ['#120a24', '#20123f', '#2c1a48'],
  };
  const sky    = SKIES[night];
  const mLight = night === 'dusk' ? '#ffedcf' : '#f3f1ff';
  const mDark  = night === 'dusk' ? '#f0c88f' : '#cdc8e6';
  const haloC  = night === 'dusk' ? '#ffcf8f' : '#cfd6ff';
  const fogC   = night === 'dusk' ? '#dcc7bd' : '#c7bce0';
  const moonY  = night === 'dusk' ? 66 : 50;

  // a few twinkling stars, biased upper-right so the moon side and the
  // badge centre both stay calm
  let stars = '';
  for (let i = 0; i < 9; i++) {
    const x = rnd(150, 346), y = rnd(8, 72), r = rnd(0.7, 1.6), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${i % 4 ? '#fff' : '#ffe6a6'}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // full moon: a pulsing halo behind a softly-shaded disc with a few craters
  const moon = `<g transform="translate(76,${moonY})">
    <g class="glow"><circle r="60" fill="url(#halo_${uid})"/></g>
    <circle r="30" fill="url(#moon_${uid})"/>
    <circle cx="-9" cy="-7" r="4.6" fill="rgba(60,40,90,.10)"/>
    <circle cx="7" cy="4" r="6" fill="rgba(60,40,90,.09)"/>
    <circle cx="-4" cy="11" r="3.2" fill="rgba(60,40,90,.08)"/>
    <circle cx="12" cy="-9" r="2.6" fill="rgba(60,40,90,.08)"/>
  </g>`;

  // a small flight of bats crossing the upper sky, all above the badge zone
  const bats = hwBat(30, 0.62, 18, -11, -0.1)
             + hwBat(42, 1, 13, -2, 0)
             + hwBat(52, 0.85, 14.5, -6, -0.15)
             + hwBat(60, 0.72, 16.5, -8, -0.2);

  // a corner cobweb (top-right) with a little spider on its dropline
  const web = hwCobweb(360, 0, 56, Math.PI / 2, Math.PI)
    + '<g stroke="rgba(212,204,236,.42)" stroke-width="0.7"><line x1="326" y1="31" x2="326" y2="47"/></g>'
    + '<g transform="translate(326,50)"><ellipse rx="2" ry="2.6" fill="#160b26"/><g stroke="#160b26" stroke-width="0.7" stroke-linecap="round"><path d="M-2,-1 L-5,-3 M-2,1 L-5,2 M-2,2.2 L-4,4.4 M2,-1 L5,-3 M2,1 L5,2 M2,2.2 L4,4.4"/></g></g>';

  // a small graveyard on the left: fence behind two leaning headstones,
  // with a scatter of ground gourds (kept off the calm centre)
  const yard = hwFence(-8, 132, 187, '#0f0a1c')
    + hwGrave(38, 191, 1, -5)
    + hwGrave(112, 189, 0.82, 6);
  const gourds = hwGourd(64, 201, 0.7) + hwGourd(96, 200, 0.95) + hwGourd(232, 201, 0.72);

  // wispy spirit orbs drifting in the mid-ground, framing (never over) centre
  const orbs = hwOrb(46, 132, 1, uid, 0, 3.4)
             + hwOrb(120, 152, 0.7, uid, -1.2, 4.2)
             + hwOrb(300, 150, 0.85, uid, -0.6, 3.8)
             + hwOrb(332, 114, 0.6, uid, -2, 4.6);

  const fog = hwFog(70, 196, 1, 0.9, 13, 0, uid)
            + hwFog(250, 201, 1.15, 0.8, 16, -5, uid)
            + hwFog(180, 207, 1.35, 0.7, 19, -9, uid);

  const heroEl = hero === 'ghost'
    ? hwGhost(256, 120, 1, uid, 0)
    : hwJack(256, 202, 1.05, uid);

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Halloween night — a haloed full moon and a bare tree over low fog, with ${hero === 'ghost' ? 'a drifting ghost' : 'a glowing jack-o’-lantern'}, flapping bats and twinkling stars">
    <defs>
      <linearGradient id="sky_${uid}" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="${sky[0]}"/><stop offset="0.55" stop-color="${sky[1]}"/><stop offset="1" stop-color="${sky[2]}"/>
      </linearGradient>
      <radialGradient id="halo_${uid}">
        <stop offset="0" stop-color="${haloC}" stop-opacity="0.5"/><stop offset="0.45" stop-color="${haloC}" stop-opacity="0.16"/><stop offset="1" stop-color="${haloC}" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="moon_${uid}" cx="0.4" cy="0.36" r="0.75">
        <stop offset="0" stop-color="${mLight}"/><stop offset="1" stop-color="${mDark}"/>
      </radialGradient>
      <radialGradient id="fog_${uid}">
        <stop offset="0" stop-color="${fogC}" stop-opacity="0.5"/><stop offset="1" stop-color="${fogC}" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="pkBody_${uid}" cx="0.4" cy="0.32" r="0.85">
        <stop offset="0" stop-color="#ffa63a"/><stop offset="0.6" stop-color="#f07d1c"/><stop offset="1" stop-color="#cf560f"/>
      </radialGradient>
      <radialGradient id="pkGlow_${uid}">
        <stop offset="0" stop-color="#ff9330" stop-opacity="0.6"/><stop offset="0.55" stop-color="#ff7a1e" stop-opacity="0.22"/><stop offset="1" stop-color="#ff7a1e" stop-opacity="0"/>
      </radialGradient>
      <linearGradient id="pkFace_${uid}" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff2b8"/><stop offset="1" stop-color="#ff9a1e"/>
      </linearGradient>
      <linearGradient id="ghost_${uid}" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" stop-opacity="0.95"/><stop offset="1" stop-color="#e7e0ff" stop-opacity="0.66"/>
      </linearGradient>
      <radialGradient id="ghostGlow_${uid}">
        <stop offset="0" stop-color="#ffffff" stop-opacity="0.4"/><stop offset="1" stop-color="#ffffff" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="orbGlow_${uid}">
        <stop offset="0" stop-color="#c8f0dd" stop-opacity="0.55"/><stop offset="1" stop-color="#c8f0dd" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <rect width="360" height="220" fill="url(#sky_${uid})"/>
    ${stars}
    ${moon}
    ${web}
    ${bats}
    <path d="M-10,168 Q 90,150 200,164 Q 300,174 370,156 V 220 H -10 Z" fill="#1c1236" opacity="0.92"/>
    ${hwBareTree(320, 197, 1.35, '#140b22')}
    <path d="M-10,192 Q 180,184 370,190 V 220 H -10 Z" fill="#130a22"/>
    ${yard}
    ${gourds}
    ${heroEl}
    ${orbs}
    ${fog}
  </svg>`;
}

export { halloweenScene };
